import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Phone, Menu, X } from "lucide-react";
import { TEST_IDS } from "@/constants/testIds";

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
      scrolled ? "bg-[#0d0b09]/90 backdrop-blur-md border-b border-[rgba(242,207,139,0.18)]" : "bg-transparent"
    }`}>
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="flex items-center justify-between" style={{ height: "68px" }}>
          <a href="/" data-testid={TEST_IDS.headerLogo} className="flex items-center gap-3 shrink-0">
            <img src="/assets/epsom-logo.webp" alt="Epsom Wellness" className="h-8 sm:h-10 w-auto brightness-0 invert opacity-90" />
            <span className="hidden sm:inline font-serif text-[15px] sm:text-[19px] tracking-[0.18em] text-[#f8f0df]">
              EPSOM <span className="text-[#f2cf8b]">WELLNESS</span>
            </span>
          </a>

          <nav className="hidden md:flex items-center gap-6 text-xs tracking-[0.12em] uppercase text-[#bdb3a4]">
            <span>Andheri W</span>
            <span className="text-[#665846]">·</span>
            <span>Santacruz W</span>
            <span className="text-[#665846]">·</span>
            <span>Borivali W</span>
          </nav>

          <div className="flex items-center gap-3">
            <a href="#booking" data-testid={TEST_IDS.headerBookBtn}
              className="inline-flex items-center gap-2 px-4 sm:px-5 py-2.5 rounded-full border border-[#d7a85c] bg-[#d7a85c] text-[#17110a] font-extrabold text-xs sm:text-sm">
              RESERVE ₹5
            </a>
            <button className="md:hidden p-2 text-[#bdb3a4]" onClick={() => setMenuOpen(!menuOpen)}>
              {menuOpen ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
            </button>
          </div>
        </div>
      </div>

      <AnimatePresence>
        {menuOpen && (
          <motion.div initial={{ opacity: 0, height: 0 }} animate={{ opacity: 1, height: "auto" }} exit={{ opacity: 0, height: 0 }}
            className="md:hidden bg-[#0d0b09] border-b border-[rgba(242,207,139,0.18)] overflow-hidden">
            <nav className="px-5 py-4 space-y-3">
              {[["#experience","The Experience"],["#pricing","Pricing"],["#booking","Book Now"],["#faq","FAQ"]].map(([href,label])=>(
                <a key={href} href={href} onClick={() => setMenuOpen(false)} className="block text-sm font-medium text-[#bdb3a4] py-2">{label}</a>
              ))}
              <a href="tel:+919867670764" className="block text-sm font-medium text-[#f2cf8b] py-2">Call: +91 9867670764</a>
            </nav>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
}
